import { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import {
  FaChevronDown,
  FaChevronRight,
  FaChevronUp,
  FaPlus,
} from "react-icons/fa";
import { changeCurrentWorkspace } from "@/services/workspaces";
import * as S from "./styles";

const ONE_WORKSPACE = 1;

const WorkspaceContent = ({
  workspaces,
  handleSetWorkspace,
  handleWorkspaceChange,
}) => {
  return createPortal(
    <>
      <S.Overlay onClick={handleWorkspaceChange} />
      <S.WorkspaceContent>
        <S.Title>Selecione o Workspace</S.Title>

        <S.Workspaces>
          {workspaces?.map((workspace) => (
            <S.Workspace
              key={`workspace-${workspace?.id}`}
              onClick={() => handleSetWorkspace(workspace)}
            >
              <S.WorkspaceName>{workspace?.name}</S.WorkspaceName>
              <FaChevronRight />
            </S.Workspace>
          ))}

          <S.Workspace
            isNew
            // onClick={() => handleSetWorkspace(null)}
          >
            <S.WorkspaceName>Adicionar novo workspace</S.WorkspaceName>
            <FaPlus />
          </S.Workspace>
        </S.Workspaces>
      </S.WorkspaceContent>
    </>,
    document.body
  );
};

const SwitchWorkspace = ({ workspaces, currentWorkspace }) => {
  const [changeWorkspace, setChangeWorkspace] = useState(false);

  const handleWorkspaceChange = useCallback(() => {
    setChangeWorkspace(!changeWorkspace);
  }, [changeWorkspace]);

  const handleSetWorkspace = useCallback((workspace) => {
    const callback = () => window.location.reload();
    changeCurrentWorkspace(workspace?._id, workspace, callback);
  }, []);

  if (!workspaces || workspaces?.length === ONE_WORKSPACE) return null;

  return (
    <S.Container>
      <S.Workspace onClick={handleWorkspaceChange}>
        <S.WorkspaceName>{currentWorkspace?.name}</S.WorkspaceName>
        {changeWorkspace ? <FaChevronUp /> : <FaChevronDown />}
        {changeWorkspace && (
          <WorkspaceContent
            workspaces={workspaces}
            handleSetWorkspace={handleSetWorkspace}
            handleWorkspaceChange={handleWorkspaceChange}
          />
        )}
      </S.Workspace>
    </S.Container>
  );
};

export default SwitchWorkspace;
